/* ACES Solar - P0 Downpayment landing page
   Upload under Online Store > Themes > Edit code > Assets.
   Edit CONFIG below: promoEnd, savings assumptions, formEndpoint. */
var ACSROOT=document.getElementById('acs-lp')||document;
const CONFIG = {
promoEnd:'2026-09-30T23:59:59+08:00',
annualRateIncrease:0.04,
solarOffset:0.65,
formEndpoint:''
};
const clock=document.getElementById('acs-clock');
const end=new Date(CONFIG.promoEnd).getTime();
function tickClock(){
const d=end-Date.now();
if(d<=0){clock.textContent='Final day';return;}
const day=Math.floor(d/864e5),h=Math.floor(d%864e5/36e5),
m=Math.floor(d%36e5/6e4),s=Math.floor(d%6e4/1e3);
clock.textContent=`${day}d ${String(h).padStart(2,'0')}h ${String(m).padStart(2,'0')}m ${String(s).padStart(2,'0')}s`;
}
tickClock();setInterval(tickClock,1000);
let bill=12000;
const started=Date.now();
const tickEl=document.getElementById('acs-tick');
const peso=n=>'₱'+n.toLocaleString('en-PH',{minimumFractionDigits:2,maximumFractionDigits:2});
function runMeter(){
const perSec=(bill*12)/(365*24*60*60);
tickEl.textContent=peso(((Date.now()-started)/1000)*perSec);
requestAnimationFrame(runMeter);
}
runMeter();
ACSROOT.querySelectorAll('.acs-pill').forEach(p=>{
p.addEventListener('click',()=>{
ACSROOT.querySelectorAll('.acs-pill').forEach(x=>x.setAttribute('aria-pressed','false'));
p.setAttribute('aria-pressed','true');
bill=+p.dataset.bill;
document.getElementById('acs-billpick').value=String(bill);
updateCompare();
});
});
const pick=document.getElementById('acs-billpick');
const pesoR=n=>'₱'+Math.round(n).toLocaleString('en-PH');
function tenYear(monthly,offset){
let total=0,m=monthly*(1-offset);
for(let y=0;y<10;y++){total+=m*12;m*=(1+CONFIG.annualRateIncrease);}
return total;
}
function updateCompare(){
const b=+pick.value;
document.getElementById('acs-doNothing').textContent=pesoR(tenYear(b,0));
document.getElementById('acs-withSolar').textContent=pesoR(tenYear(b,CONFIG.solarOffset));
}
pick.addEventListener('change',()=>{
bill=+pick.value;
ACSROOT.querySelectorAll('.acs-pill').forEach(x=>
x.setAttribute('aria-pressed',x.dataset.bill===pick.value?'true':'false'));
updateCompare();
if(window.fbq)fbq('trackCustom','CalculatorUsed',{bill_band:pick.value});
});
updateCompare();
const qs=new URLSearchParams(location.search);

/* ------------------------------------------------------------------
   ATTRIBUTION FORWARDING
   The forms now live on Odoo, on a different origin, so the hidden
   UTM fields that used to sit in this page are gone. Instead we append
   the campaign parameters to each iframe URL. Odoo can then read them
   from its own query string and write them onto the lead.

   In Odoo, add hidden fields to the /zero-promo form named
   utm_source, utm_medium, utm_campaign, utm_content, fbclid, page_url
   and populate them from window.location.search on that page.
   Without that step attribution stops at the iframe boundary.
   ------------------------------------------------------------------ */
(function(){
  var keys=['utm_source','utm_medium','utm_campaign','utm_content','fbclid'];
  var extra=[];
  keys.forEach(function(k){
    var v=qs.get(k);
    if(v) extra.push(k+'='+encodeURIComponent(v));
  });
  extra.push('page_url='+encodeURIComponent(location.href));
  if(!extra.length) return;
  ACSROOT.querySelectorAll('.acs-odooframe iframe').forEach(function(f){
    f.src += (f.src.indexOf('?')>-1?'&':'?') + extra.join('&');
  });
})();

/* ------------------------------------------------------------------
   LEAD EVENT
   The submit happens inside the Odoo iframe, on another origin, so
   this page cannot see it and fbq('track','Lead') cannot fire here.
   Install the Meta Pixel on the Odoo side and fire Lead on the
   /zero-promo thank-you page instead.
   ------------------------------------------------------------------ */

/* ------------------------------------------------------------------
   OPTIONAL EXACT HEIGHT - not required
   The wrapper in aces-lp.css crops the frame to --acs-frame-h, which
   already hides the empty page background. This listener only does
   anything if the Odoo page is ever set up to post its height up.
   ------------------------------------------------------------------ */
window.addEventListener('message', function (e) {
  if (e.origin !== 'https://acessolar.odoo.com') return;
  var h = e.data && e.data.acesHeight;
  if (!h) return;
  ACSROOT.querySelectorAll('.acs-odooframe').forEach(function (w) {
    var f = w.querySelector('iframe');
    if (f && f.contentWindow === e.source) w.style.height = h + 'px';
  });
});